import React, { useEffect, useState } from "react";
import axiosInstance from "services/AxiosInstance";
import { SpinnerCitoPlus } from "jsx/components/CitoPlus/components/loadingLogo";
import { Modal } from "react-bootstrap";
import {
  notifyError,
  notifySuccess,
} from "jsx/components/CitoPlus/components/CitoPlusToastr";
import { handleErrors } from "jsx/components/CitoPlus/components/ErrorHandlingComponent";

const PreRegistroVisitantesQR = () => {
  const URL = "/api/v3/usuarios/access-link/pre-registro-visitante/";

  const [codigoQR, setCodigoQR] = useState({
    pre_registro_visitantes_qr: "",
  });
  const [showModal, setShowModal] = useState(false);
  const [mensajePersonalizado, setMensajePersonalizado] = useState(
    "Hola, te envío el código QR para que puedas pre-registrar a tus visitantes de forma sencilla y segura.",
  );
  const [enviandoMensaje, setEnviandoMensaje] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      setErrorMessage("");
      try {
        const response = await axiosInstance.get(URL);
        const data = await response.data;
        console.log("QR Code Data:", data.qr);
        setCodigoQR({
          pre_registro_visitantes_qr: data.qr,
        });
      } catch (error) {
        console.error("Error fetching data:", error);
        if (error.response && error.response.status === 400) {
          const errorData = error.response.data;
          if (errorData.errors && errorData.errors.length > 0) {
            setErrorMessage(errorData.errors[0].detail);
          } else {
            setErrorMessage("Error de validación al obtener el QR.");
          }
        } else {
          setErrorMessage("Error al cargar el QR. Inténtalo de nuevo.");
        }
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleEnviarMensaje = async () => {
    if (!mensajePersonalizado.trim()) {
      notifyError("El mensaje no puede estar vacío");
      return;
    }

    setEnviandoMensaje(true);
    try {
      // Aquí iría la llamada a la API para enviar el mensaje
      await axiosInstance.post(`${URL}enviar-a-todos-whatsapp/`, {
        mensaje: mensajePersonalizado,
      });

      notifySuccess("QR enviado exitosamente a todos los residentes");
      setShowModal(false);
    } catch (error) {
      handleErrors(error);
    } finally {
      setEnviandoMensaje(false);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setMensajePersonalizado(
      "Hola, te envío el código QR para que puedas pre-registrar a tus visitantes de forma sencilla y segura.",
    );
  };

  return (
    <>
      <div className="row justify-content-center">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-header border-0 justify-content-center">
              <h4 className="fs-20">QR Pre-registro Visitantes</h4>
            </div>
            <div className="card-body text-center" style={{ padding: "20px" }}>
              <div className="mb-4">
                <button
                  className="btn btn-primary"
                  onClick={() => setShowModal(true)}
                  disabled={!codigoQR.pre_registro_visitantes_qr}
                >
                  <i className="fa fa-paper-plane me-2"></i>
                  Enviar a todos los residentes
                </button>
              </div>
              <div>
                {isLoading ? (
                  <SpinnerCitoPlus text="Cargando QR Pre-registro Visitantes..." />
                ) : errorMessage ? (
                  <div className="alert alert-danger" role="alert">
                    {errorMessage}
                  </div>
                ) : codigoQR.pre_registro_visitantes_qr ? (
                  <img
                    src={codigoQR.pre_registro_visitantes_qr}
                    alt="Código QR Pre-registro Visitantes"
                    className="img-fluid"
                    style={{ maxWidth: "300px", height: "auto" }}
                  />
                ) : (
                  <div className="alert alert-warning" role="alert">
                    No se pudo cargar el QR.
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal para envío personalizado */}
      <Modal show={showModal} onHide={handleCloseModal} size="md" centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <i className="fa fa-paper-plane me-2"></i>
            Enviar QR a Residentes
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="form-group mb-3">
            <label
              htmlFor="mensajePersonalizado"
              className="form-label font-weight-bold"
            >
              Mensaje personalizado:
            </label>
            <textarea
              id="mensajePersonalizado"
              className="form-control"
              rows="4"
              value={mensajePersonalizado}
              onChange={(e) => setMensajePersonalizado(e.target.value)}
              placeholder="Escriba su mensaje personalizado..."
              disabled={enviandoMensaje}
            />
            <small className="text-muted">
              Este mensaje acompañará el código QR que se enviará a todos los
              residentes.
            </small>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={handleCloseModal}
            disabled={enviandoMensaje}
          >
            Cancelar
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleEnviarMensaje}
            disabled={enviandoMensaje || !mensajePersonalizado.trim()}
          >
            {enviandoMensaje ? (
              <>
                <i className="fa fa-spinner fa-spin me-2"></i>
                Enviando...
              </>
            ) : (
              <>
                <i className="fa fa-paper-plane me-2"></i>
                Enviar QR
              </>
            )}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default PreRegistroVisitantesQR;
